import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import { Box, Typography, Paper, IconButton } from "@mui/material";
import { Block, Edit } from "@mui/icons-material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import * as Mui from "@mui/material";
import { customAPI } from "services/utils/CustomAPI";
import { CustomFilter } from "components/CustomComponents/CustomFilter";
import { DoubleArrow } from "@mui/icons-material";
import { eligibleEmployee } from "pages/PayRoll/PayRollHeaders";
import { tooltipStyleProps } from "services/constants/Styles";
import {
  doubleArrowStyle,
  themes,
  infoStyle,
  scrollTop,
  stickyHeader,
  tableRowSize,
} from "services/constants";
import { useSelector } from "react-redux";
import moment from "moment";
export const ViewPayCycleIncentive = ({
  selectedRecord,
  onClose,
  reCallApi,
  screen,
  goEditScreen,
}) => {
  const requestCompanyId = useSelector((state) => state.tokenReducer.topbarCompanyId);
  const { domain, topbarCompanyName } = useSelector(
    (state) => state.tokenReducer,
  );
  const [filteredRecords, setFilteredRecords] = useState([]);
  const [tab, setTab] = useState("Qualified");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const containerRef = useRef(null);

  const getTableData = () => {
    if (!selectedRecord) return [];

    switch (tab) {
      case "Qualified":
        return selectedRecord.qualified_users;

      case "Not Qualified":
        return selectedRecord.not_qualified_users;

      case "Eligible":
        return [
          ...selectedRecord.qualified_users,
          ...selectedRecord.not_qualified_users,
        ];

      default:
        return [];
    }
  };

  const handleChangePage = (_, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  useEffect(() => {
    scrollTop(containerRef);
  }, [page]);

  const handleFilteredDataChange = useCallback(
    (data) => {
      setFilteredRecords(data);
      if (page * rowsPerPage >= data.length) {
        setPage(0);
      }
    },
    [page, rowsPerPage],
  );

  const save_incentive_details = async (status) => {
    const payload = {
      status: status,
    };
    const response = await customAPI(
      `${domain}payroll/incentive/incentive-crud/${selectedRecord?.id}/&company_id=${requestCompanyId}`,
      "PATCH",
      payload,
    );
    if (response.ok) {
      reCallApi(true);
      onClose();
    }
  };

  const IncentiveSummaryCard = (selectedRecord) => {
    const rowStyle = {
      display: "flex",
      justifyContent: "space-between",
      mb: 2,
    };

    const labelStyle = {
      fontWeight: 500,
      color: "#333",
      minWidth: 200,
    };

    const valueStyle = {
      color: "#666",
    };
    return (
      <Paper
        elevation={0}
        sx={{
          border: "1px solid #dcdcdc",
          borderRadius: 2,
          p: 3,
          maxWidth: 650,
          backgroundColor: "#fafafa",
        }}
      >
        {/* Date Range */}
        <Box sx={rowStyle}>
          <Typography sx={labelStyle}>Date Range</Typography>
          <Typography sx={valueStyle}>
            {selectedRecord?.start_date} to {selectedRecord?.end_date}
          </Typography>
        </Box>

        {/* Cycle Payrun */}
        <Box sx={rowStyle}>
          <Typography sx={labelStyle}>Cycle Payrun</Typography>
          <Typography sx={valueStyle}>
            {selectedRecord?.payroll_schedule_name}
          </Typography>
        </Box>

        {/* Incentive Template */}
        <Box sx={rowStyle}>
          <Typography sx={labelStyle}>Incentive Template</Typography>
          <Typography sx={valueStyle}>
            {selectedRecord?.incentive_template_name}
          </Typography>
        </Box>

        {/* Incentive Type */}
        <Box sx={rowStyle}>
          <Typography sx={labelStyle}>Incentive Type:</Typography>
          <Typography sx={{ color: "#16a34a", fontWeight: 600 }}>
            {selectedRecord?.incentive_template?.incentive_type}
          </Typography>
        </Box>

        <Box sx={rowStyle}>
          <Typography sx={labelStyle}>Eligibility Logic:</Typography>
          <Typography sx={{ color: "#16a34a", fontWeight: 600 }}>
            {selectedRecord?.incentive_template?.eligibility_logic}
          </Typography>
        </Box>

        {/* Eligibility */}
        <Box sx={rowStyle}>
          <Typography sx={labelStyle}>Eligibility:</Typography>
          <Typography sx={valueStyle}>
            {Object.entries(
              selectedRecord?.incentive_template?.eligibility_summary || {},
            ).map(([key, values]) => (
              <Box key={key} display="flex" gap={1}>
                <Typography sx={{ fontWeight: 500 }}>{key}:</Typography>
                <Typography color="text.secondary">
                  {values.map((v) => v.name).join(", ")}
                </Typography>
              </Box>
            ))}
          </Typography>
        </Box>

        {/* Qualification */}
        <Box sx={rowStyle}>
          <Typography sx={labelStyle}>Qualification:</Typography>
          <Typography sx={valueStyle}>
            {" "}
            {selectedRecord?.incentive_template?.incentive_type} ≥{" "}
            {selectedRecord?.incentive_template?.qualification_value}
          </Typography>
        </Box>

        {/* Payout Type */}
        <Box sx={rowStyle}>
          <Typography sx={labelStyle}>Payout Type:</Typography>
          <Typography>
            {selectedRecord?.incentive_template?.payout_value} /{" "}
            {selectedRecord?.incentive_template?.payout_basis}
          </Typography>
        </Box>
        {selectedRecord?.incentive_template?.payout_type ===
          "Percentage of salary" && (
          <Box sx={rowStyle}>
            <Typography sx={labelStyle}>Measurement Period (Days):</Typography>
            <Typography>
              {selectedRecord?.incentive_template?.salary_divisor}
            </Typography>
          </Box>
        )}

        {/* Max Cap */}
        {selectedRecord?.incentive_template?.maximum_cap && (
          <Box sx={rowStyle}>
            <Typography sx={labelStyle}>Maximum Capped Amount:</Typography>
            <Typography sx={valueStyle}>
              {selectedRecord?.incentive_template?.maximum_cap}
            </Typography>
          </Box>
        )}
      </Paper>
    );
  };

  const statusStyles = {
    Inprogress: {
      color: "#d97706",
      border: "#f59e0b",
      bg: "#fff7ed",
    },
    Completed: {
      color: "#16a34a",
      border: "#22c55e",
      bg: "#eafaf1",
    },
    Rejected: {
      color: "#dc2626",
      border: "#ef4444",
      bg: "#fde8e8",
    },
  };

  const StatusBadge = ({ status }) => {
    const style = statusStyles[status] || statusStyles.Inprogress;

    return (
      <Box
        sx={{
          px: 2.5,
          py: 0.8,
          borderRadius: "20px",
          border: `1px solid ${style.border}`,
          backgroundColor: style.bg,
          display: "inline-flex",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            color: style.color,
            fontWeight: 500,
            fontSize: 13,
          }}
        >
          {status}
        </Typography>
      </Box>
    );
  };

  const reopen_incentive = async (status) => {
    const payload = { status: "Inprogress" };
    let URL = `${domain}payroll/incentive/incentive-crud/${selectedRecord?.id}/&company_id=${requestCompanyId}`;
    const response = await customAPI(URL, "PATCH", payload);
    if (response.ok) {
      reCallApi(true);
      onClose();
    }
  };

  const reportMetadata = useMemo(
    () => ({
      "Company Name": topbarCompanyName || "N/A",
      "Report Generated On": moment().format("DD/MM/YYYY HH:mm:ss"),
    }),
    [topbarCompanyName],
  );

  return (
    <Box sx={{ height: "100%" }}>
      {/* HEADER */}
      <Paper
        elevation={0}
        sx={{
          borderBottom: `1px solid ${themes?.miliedLightGray}`,
          borderRadius: 0,
          p: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          {/* LEFT SECTION */}
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <IconButton onClick={onClose} sx={doubleArrowStyle}>
              <DoubleArrow />
            </IconButton>

            <Box sx={{ ml: 2 }}>
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                {selectedRecord?.incentive_template_name}
              </Typography>

              <Typography {...infoStyle}>
                Review and manage incentive rules for employee performance
              </Typography>
            </Box>
          </Box>

          {/* RIGHT ICON BUTTONS */}
          {screen !== "InprogressScreen" && screen !== "CompletedScreen" ? (
            <Box sx={{ display: "flex", gap: 1 }}>
              <Mui.Tooltip arrow slotProps={tooltipStyleProps} title="Approve">
                <IconButton
                  sx={{
                    backgroundColor: "#e6f7ef",
                    "&:hover": { backgroundColor: "#d1f2e1" },
                  }}
                  onClick={() => {
                    save_incentive_details("Approved");
                  }}
                >
                  <CheckCircleOutlineIcon sx={{ color: "#16a34a" }} />
                </IconButton>
              </Mui.Tooltip>
              <Mui.Tooltip arrow slotProps={tooltipStyleProps} title="Reject">
                <IconButton
                  sx={{
                    backgroundColor: "#fde8e8",
                    "&:hover": { backgroundColor: "#fbd5d5" },
                  }}
                  onClick={() => {
                    save_incentive_details("Rejected");
                  }}
                >
                  <Block sx={{ color: "#dc2626" }} />
                </IconButton>
              </Mui.Tooltip>
            </Box>
          ) : (
            screen !== "CompletedScreen" &&
            selectedRecord?.status === "Inprogress" && (
              <Box sx={{ display: "flex", gap: 1 }}>
                <IconButton
                  sx={{
                    backgroundColor: "#fde8e8",
                    "&:hover": { backgroundColor: "#fbd5d5" },
                  }}
                  onClick={() => {
                    goEditScreen(true);
                  }}
                >
                  <Edit sx={{ color: "#dc2626" }} />
                </IconButton>
              </Box>
            )
          )}
        </Box>
      </Paper>
      <Box sx={{ padding: 1, display: "flex", justifyContent: "flex-end" }}>
        {(selectedRecord?.status === "Approved" ||
          selectedRecord?.status === "Rejected") && (
          <Box sx={{ paddingRight: 1 }}>
            <Box
              onClick={() => {
                reopen_incentive("Inprogress");
              }}
              sx={{
                px: 2.5,
                py: 0.8,
                borderRadius: "20px",
                border: `1px solid #16a34a`,
                backgroundColor: "#16a34a",
                display: "inline-flex",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  color: "white",
                  fontWeight: 500,
                  fontSize: 13,
                }}
              >
                Reopen
              </Typography>
            </Box>
          </Box>
        )}
        <span sx={{ paddingLeft: 1 }}></span>
        <StatusBadge status={selectedRecord?.status} />
      </Box>
      <Mui.Box sx={{ padding: 2 }}>
        {IncentiveSummaryCard(selectedRecord)}
      </Mui.Box>
      {/* TABS */}
      <Box
        mt={3}
        sx={{ backgroundColor: "#f5f5fd", paddingLeft: 1, paddingRight: 1 }}
      >
        <Typography variant="h6">Qualified Employee Preview</Typography>

        {/* Custom Tabs */}
        <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
          {["Qualified", "Not Qualified", "Eligible"].map((label) => (
            <Box
              key={label}
              sx={{
                padding: "10px 20px",
                backgroundColor: tab === label ? "white" : "transparent",
                color: tab === label ? "primary.main" : "text.secondary",
                fontWeight: 600,
                cursor: "pointer",
                borderTopLeftRadius: "8px",
                borderTopRightRadius: "8px",
                marginBottom: "-1px",
                border: "1px solid",
                borderColor: tab === label ? "grey.300" : "transparent",
                "&:hover": {
                  backgroundColor: tab === label ? "white" : "grey.100",
                },
              }}
              onClick={() => setTab(label)}
            >
              {label}
            </Box>
          ))}
        </Box>

        {/* TABLE */}
        <Paper>
          <CustomFilter
            title={`${tab} Employees`}
            filterHeaders={eligibleEmployee}
            data={getTableData()}
            filteredData={filteredRecords}
            onFilteredDataChange={handleFilteredDataChange}
            screenAccess={true}
            viewFilter={false}
            downloadFormats={["excel", "pdf", "csv"]}
            includeMetadata={true}
            metadata={reportMetadata}
          />{" "}
          <Mui.Box sx={{ m: 1 }}>
            <Mui.TableContainer
              ref={containerRef}
              sx={{
                maxHeight: "60vh",
                overflow: "auto",
              }}
            >
              <Mui.Table size="small" sx={{ minWidth: 450 }}>
                <Mui.TableHead sx={stickyHeader}>
                  <Mui.TableRow sx={tableRowSize}>
                    <Mui.TableCell>Employee Id</Mui.TableCell>
                    <Mui.TableCell>Name</Mui.TableCell>
                    <Mui.TableCell>Dept</Mui.TableCell>
                    <Mui.TableCell>Designation</Mui.TableCell>
                  </Mui.TableRow>
                </Mui.TableHead>
                <Mui.TableBody>
                  {filteredRecords?.map((row) => (
                    <Mui.TableRow key={row.id}>
                      <Mui.TableCell>{row.employee_id}</Mui.TableCell>
                      <Mui.TableCell>
                        <Mui.Stack direction="Row">
                          <Mui.Avatar
                            sx={{
                              width: 25,
                              height: 25,
                            }}
                            alt="Remy Sharp"
                            src={row.image_url}
                          />
                          <Mui.Typography
                            sx={{
                              paddingLeft: 1,
                            }}
                          >
                            {row.name}
                          </Mui.Typography>
                        </Mui.Stack>
                      </Mui.TableCell>
                      <Mui.TableCell>{row.department}</Mui.TableCell>
                      <Mui.TableCell>{row.designation || "-"}</Mui.TableCell>
                    </Mui.TableRow>
                  ))}

                  {filteredRecords?.length === 0 && (
                    <Mui.TableRow>
                      <Mui.TableCell colSpan={4} align="center">
                        No Data Available
                      </Mui.TableCell>
                    </Mui.TableRow>
                  )}
                </Mui.TableBody>
              </Mui.Table>
            </Mui.TableContainer>{" "}
          </Mui.Box>
          {filteredRecords.length > 25 && (
            <Mui.TablePagination
              component="div"
              rowsPerPageOptions={[25, 50, 75, 100]}
              count={filteredRecords.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          )}{" "}
        </Paper>
      </Box>
    </Box>
  );
};
